module.exports = __webpack_public_path__ + "fonts/manrope-bold.ecdaf6c1.otf";